import { render } from "./MembershipUser.vue?vue&type=template&id=12455972"
import script from "./MembershipUser.vue?vue&type=script&lang=js"
export * from "./MembershipUser.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__